import React, { Component } from "react";
import ListPanel from "./list-panel/ListPanelWithStore";
import ContentPanel from "./content-panel/ContentPanelWithStore";
import InfoPanel from "./info-panel/InfoPanelWithStore";

export default class ModuleCaseManagement extends Component {
  render() {
    return [
      <ListPanel key="list" />,
      <ContentPanel key="content" />,
      <InfoPanel key="info" />
    ];
  }
}



// WEBPACK FOOTER //
// ./src/module-case-management/ModuleCaseManagement.js